var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ig",
    transform: "translate(-100 -1012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "instagram_1_",
    "data-name": "instagram (1)",
    d: "M4.969,7.453A2.484,2.484,0,1,1,7.453,9.937,2.484,2.484,0,0,1,4.969,7.453m-1.343,0A3.827,3.827,0,1,0,7.453,3.626,3.827,3.827,0,0,0,3.626,7.453m6.911-3.978a.895.895,0,1,0,.895-.894.895.895,0,0,0-.895.894m-6.1,10.045a4.117,4.117,0,0,1-1.384-.256A2.318,2.318,0,0,1,2.2,12.7a2.3,2.3,0,0,1-.557-.857,4.117,4.117,0,0,1-.256-1.384c-.036-.786-.043-1.022-.043-3.012s.008-2.226.043-3.012a4.136,4.136,0,0,1,.256-1.384A2.318,2.318,0,0,1,2.2,2.2a2.3,2.3,0,0,1,.857-.557,4.117,4.117,0,0,1,1.384-.256c.786-.036,1.022-.043,3.011-.043s2.226.008,3.012.043a4.136,4.136,0,0,1,1.384.256,2.311,2.311,0,0,1,.857.557,2.313,2.313,0,0,1,.557.857,4.117,4.117,0,0,1,.256,1.384c.036.786.043,1.022.043,3.012s-.007,2.226-.043,3.012a4.132,4.132,0,0,1-.256,1.384,2.467,2.467,0,0,1-1.415,1.414,4.117,4.117,0,0,1-1.384.256c-.786.036-1.022.043-3.012.043s-2.226-.007-3.011-.043M4.38.045A5.466,5.466,0,0,0,2.571.391a3.657,3.657,0,0,0-1.32.86,3.647,3.647,0,0,0-.86,1.32A5.466,5.466,0,0,0,.045,4.38C.008,5.175,0,5.429,0,7.453S.008,9.73.045,10.525a5.466,5.466,0,0,0,.346,1.809,3.644,3.644,0,0,0,.86,1.32,3.655,3.655,0,0,0,1.32.86,5.47,5.47,0,0,0,1.809.346c.8.036,1.049.045,3.073.045s2.278-.008,3.073-.045a5.466,5.466,0,0,0,1.809-.346,3.811,3.811,0,0,0,2.18-2.18,5.451,5.451,0,0,0,.346-1.809c.036-.8.045-1.049.045-3.073S14.9,5.175,14.86,4.38a5.466,5.466,0,0,0-.346-1.809,3.665,3.665,0,0,0-.86-1.32,3.655,3.655,0,0,0-1.32-.86A5.458,5.458,0,0,0,10.526.045C9.731.009,9.477,0,7.453,0S5.175.008,4.38.045",
    transform: "translate(107.419 1019.643)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    transform: "translate(100 1012)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIg);
export default __webpack_public_path__ + "static/media/ig.5bcd09393c2b45391784d13ffdd02c43.svg";
export { ForwardRef as ReactComponent };